export default "__VITE_ASSET__944c4141__"